<template>
  <div>
    <header-country
      :link="banner.link"
      :open-link-in-new-tab="openLinkInNewTab"
      :country-code="countryCode"
      :url-key="urlKey"
      :caret-icon="caretIcon"
      :class-name="className"
      :enable-ga-event="enableGaEvent"
      :body="banner.body"
      v-cloak>
    </header-country>
  </div>
</template>

<script>
import HeaderCountry from './HeaderCountry.vue';

export default {
    props: {
      banners: {
        type: Array,
        required: true,
      },
      openLinkInNewTab: {
        type: Boolean,
        required: true,
      },
      className: {
        type: String,
        default: 'default',
      },
      caretIcon: {
        type: String,
      },
      countryCode: {
        type: String,
        required: true,
      },
      urlKey: {
        type: String,
        required: true,
      },
      enableGaEvent: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      HeaderCountry,
    },
    created(){
      this.banner = this.banners[Math.floor(Math.random() * this.banners.length)];
    },
    data(){
        return {
          banner: {},
        };
    },
};
</script>